import {
  ActionNodeDataDto,
  ActionNodeWebConfigDto,
} from "@babackapp/private-api-client/types";
import { EarthIcon } from "lucide-react";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { TrackingPageActionNodeEditor } from "./editor";
import { TrackingPageActionNodePanel } from "./panel";
import { WebActionNodeProps } from "./types";

const newNodeDefaultConfig: ActionNodeWebConfigDto = {
  templateId: null,
  lockedToStatus: null,
};
const newNodeDefaultValue: ActionNodeDataDto = {
  actionType: "update_web",
  config: newNodeDefaultConfig,
};

export default registerNode<WebActionNodeProps["data"]>({
  type: "action:update_web",
  name: "Update Tracking page",
  description: "Update the tracking page content",
  Icon: EarthIcon,
  category: NodeCategory.ACTION,
  color: "yellow",
  editor: {
    component: TrackingPageActionNodeEditor,
  },
  configPanel: {
    component: TrackingPageActionNodePanel,
  },
  newNodeDefaultData: newNodeDefaultValue,
});

export { TrackingPageActionNodeEditor as TrackingPageActionNodeEditor } from "./editor";
export { TrackingPageActionNodePanel as TrackingPageActionNodePanel } from "./panel";
export * from "./types";
